import { useQuery } from 'react-query';

import { indexEquipmentStatus } from '@services/queries/equipmentStatus';

import { BlockText, Container, Line } from './StatusList.styles';
import { StatusListLoading } from './StatusList.loading';
import { StatusBadge } from '../AssetStatus.styles';

interface IStatusList {
  setNewStatus: (newStatus: any) => void;
}

export const StatusList = ({ setNewStatus }: IStatusList) => {
  const { data, isLoading, isError } = useQuery(
    'equipmentStatus',
    indexEquipmentStatus,
  );

  if (isLoading) {
    return <StatusListLoading />;
  }

  if (isError || !data) {
    return <div>error</div>;
  }

  return (
    <Container>
      {data.map(status => (
        <Line
          key={status.id}
          onClick={() => {
            setNewStatus(status);
          }}
        >
          <StatusBadge category={status.category} />
          <BlockText>{status.name}</BlockText>
        </Line>
      ))}
    </Container>
  );
};
